var _g;
var _excluded = ["size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgPlanYouth = function SvgPlanYouth(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 14.5C31 21.955 24.956 28 17.5 28 10.042 28 4 21.956 4 14.5 4 7.042 10.043 1 17.5 1 24.955 1 31 7.043 31 14.5z",
    stroke: "#231F20",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M30 9.5H1M18 1s-4 2.913-4 8M18 1s4 2.913 4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0M24 13.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19c0 2.21 2.462 4 5.5 4 3.037 0 5.5-1.79 5.5-4H12z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2h32v32H0z"
  }))));
};
export default SvgPlanYouth;